document.addEventListener('readystatechange', () => {

    if (document.readyState !== 'complete') return;

    const setReadmoreBtns = () => {
        let readmoreElementes = document.querySelectorAll('.diu-neos-content-special-teaser__text');
        readmoreElementes.forEach(function (elem) {

            let readmoreBtn = elem.querySelectorAll('label');
            let textElem = elem.querySelectorAll('p');
            let inputElem = elem.querySelectorAll('input');

            if (readmoreBtn[0] && textElem[0] && inputElem[0]) {
                if (textElem[0].scrollHeight > textElem[0].clientHeight) {
                    readmoreBtn[0].classList.add('show');
                    readmoreBtn[0].classList.remove('hide');
                } else {
                    readmoreBtn[0].classList.remove('show');
                    readmoreBtn[0].classList.add('hide');
                    inputElem[0].checked = false;
                }
            }

        });
    }

    window.addEventListener("resize",setReadmoreBtns);
    setReadmoreBtns();
});
